// extracted by mini-css-extract-plugin
export default {"msgM":"b2db6934a5"};